import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SacredGeometry } from "./SacredGeometry";

export const Podcast = () => (
  <section id="podcast" data-testid="podcast-section" className="bg-royal py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <p className="eyebrow text-gold">The Podcast</p>
      </Reveal>
      <div className="mt-8 border border-gold/40 p-8 md:p-16 relative overflow-hidden">
        <SacredGeometry variant="star" className="right-[-3rem] bottom-[-4rem] w-96 opacity-10" />
        <div className="relative flex flex-col md:flex-row items-center gap-10 md:gap-16">
          <Reveal className="shrink-0">
            <img src="/liminal-womyn-logo.webp" alt="The Liminal Womyn podcast logo — golden orb on deep navy"
              data-testid="podcast-logo" className="w-48 md:w-72 rounded-full" />
          </Reveal>
          <div className="text-center md:text-left">
            <Reveal>
              <h2 className="font-display font-light italic text-4xl sm:text-5xl lg:text-6xl text-cream leading-tight" data-testid="podcast-title">
                The Liminal Womyn
              </h2>
              <p className="eyebrow text-gold mt-4">Worlds created in between</p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-cream/80 text-base leading-relaxed" data-testid="podcast-description">
                The presence of energy in between all things of matter — this is where we operate from;
                this is the past, the present and the future. When womyn meet in liminal spaces,
                worlds are created.
              </p>
              <p className="mt-5 text-cream/60 text-sm leading-relaxed">
                Welcome, Liminal Womyn. We connect in the in-between — a place of remembrance as you
                stand at the threshold and weave new timelines. Together, we move through the quantum
                with conscious awakening until the unseen becomes familiar recognition.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="mt-8 flex flex-wrap justify-center md:justify-start items-center gap-3" data-testid="podcast-badges">
                <span className="eyebrow bg-gold text-ink px-4 py-2 rounded-full">Launching October 7th</span>
                <span className="eyebrow border border-cream/40 text-cream px-4 py-2 rounded-full">8 episodes</span>
                <span className="eyebrow border border-cream/40 text-cream px-4 py-2 rounded-full" data-testid="podcast-platforms-badge">
                  YouTube · Podbean · Spotify
                </span>
              </div>
              <a href="http://www.liminalwomyn.com" target="_blank" rel="noopener noreferrer"
                data-testid="podcast-site-link"
                className="mt-8 inline-flex items-center gap-2 eyebrow bg-gold text-ink px-6 py-3.5 rounded-full hover:bg-cream transition-colors duration-300">
                Visit liminalwomyn.com <ArrowUpRight size={14} />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
